//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Link } from 'react-router-dom';
import { Grid } from '@mui/material';
import { Breadcrumbs, Title, TitleBar } from '../_common';
import { clearFilters } from '@/redux/slices/dataTableSlice';
import { selectDataTableAppliedSearchName, selectTableTitle } from '@/redux/selectors/dataTableSelectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const ProcessingTasksTitleBar = () => {
  const dispatch = useAppDispatch();
  const appliedSearchName = useAppSelector(selectDataTableAppliedSearchName);
  const pageTitle = useAppSelector(selectTableTitle) || 'Processing Exceptions';

  const onBreadcrumbClick = () => {
    dispatch(clearFilters());
  };

  return (
    <TitleBar>
      <Grid container justifyContent="space-between" alignItems="center">
        {!appliedSearchName ? (
          <Title>{pageTitle}</Title>
        ) : (
          <Breadcrumbs aria-label="breadcrumb">
            <Link to="/processing-exceptions" onClick={onBreadcrumbClick}>
              {pageTitle}
            </Link>
            <span>&ldquo;{appliedSearchName}&ldquo;</span>
          </Breadcrumbs>
        )}
      </Grid>
    </TitleBar>
  );
};

export default ProcessingTasksTitleBar;
